/* unplugin-vue-components disabled */import script from "./DatePickerPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatePickerPopover.vue?vue&type=script&setup=true&lang=ts"

import "./DatePickerPopover.vue?vue&type=style&index=0&id=bbdbce20&lang=css"

const __exports__ = script;

export default __exports__